import {GenericObject} from "./generic-object.model";
import {User} from "./user.model";

/**
 * Typ wyliczeniowy (Enum) określający etap, na którym znajduje się potencjalny klient
 * w lejku sprzedażowym.
 */
export enum LeadStatus {
  /** Nowe zgłoszenie. */
  NEW,
  /** Zgłoszenie wstępnie zaakceptowane/zweryfikowane przez handlowca. */
  ACCEPTED,
  /** Wykonano pierwszą próbę kontaktu z kliniką. */
  FIRST_CONTACT,
  /** Lead oczekuje na kontakt. */
  WAITING_FOR_CONTACT,
  /** Wysłano ofertę/umowę, oczekiwanie na odpowiedź ze strony kliniki. */
  WAITING_FOR_RESPONSE,
  /** Proces zakończony. */
  CLOSED,
  /** Proces anulowany (np. klient zrezygnował z rozmów). */
  CANCELED,
  /** Lead zablokowany. */
  BLOCKED,
  /** Klient podpisał umowę. */
  SIGNED,
  /** System został w pełni wdrożony w placówce klienta (Onboarding zakończony). */
  VETINEO_IMPLEMENTED
}

/**
 * Model reprezentujący Leada (Potencjalnego Klienta B2B) w wewnętrznym module CRM.
 * Przechowuje dane kontaktowe, status negocjacji oraz informacje o źródle pozyskania.
 */
export class Lead extends GenericObject {


  /** Imię osoby kontaktowej. */
  public firstName: string;
  /** Nazwisko osoby kontaktowej. */
  public lastName: string;
  /** Pełna nazwa placówki / firmy. */
  public name: string;
  /** Główny numer telefonu do kontaktu. */
  public phone: string;
  /** Adres e-mail osoby decyzyjnej. */
  public email: string;


  public postalCode: string;
  public city: string;
  public street: string;
  /** Województwo (przydatne do przydzielania leadów handlowcom wg regionów). */
  public voivodeship: string;
  /** Numer Identyfikacji Podatkowej (NIP) potencjalnego klienta. */
  public nip: string;


  /** Aktualny etap w lejku sprzedażowym. */
  public status: LeadStatus;

  /** Data wpłynęcia leada do systemu. */
  public created: string;

  /** Data zatwierdzenia/weryfikacji leada przez dział sprzedaży. */
  public dateApproved: string;

  /** Obiekt użytkownika, do którego ten lead jest przypisany.
   */
  public user: User;

  /** ID użytkownika przydatne przy zapytaniach do API. */
  public userUUID: string;

  /** Notatki wewnętrzne dotyczące ustaleń z klientem. */
  public comment: string;

  /** Powód odrzucenia/usunięcia leada. */
  public deletionReason: string;

  /** Typ oferty oferowanej klientowi.
   */
  public offerType: string;


  /** Nazwa partnera lub kliniki polecającej.
   * Ściśle powiązane z modelem `AmbassadorLink` – wskazuje, kto przyprowadził tego klienta.
   */
  public partnerName: string;

  /** Kod promocyjny wpisany przez klienta.
   */
  public promotionalCode: string;


  /** UUID klienta, który dostarczył leada.
   */
  public vClientUUID: string;

  constructor() {
    super();
  }
}
